import { render, staticRenderFns } from "./TransactionListOasisPayoutStatus.vue?vue&type=template&id=58f5f874&scoped=true&"
import script from "./TransactionListOasisPayoutStatus.vue?vue&type=script&lang=ts&"
export * from "./TransactionListOasisPayoutStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f5f874",
  null
  
)

export default component.exports